import { BrandName } from '@seek/je-shared-data/lib/types/brand';
import { useAppSelector } from '@store/hooks';
import { getBrandName } from '@store/localisation';

export function useShowCountrySelector() {
  const brand = useAppSelector(getBrandName);
  return brand !== BrandName.JOBSTREETEXPRESS;
}
